<h1 mat-dialog-title>Déconnecté</h1>
<div mat-dialog-content style="font-weight:400" >
  <p class="gs1-little">Il semble que vous ayez été déconnecté pour cause d'innactivité. Merci de vous reconnectez pour continuer à utiliser vos applications GS1 France.</p>
</div>
<div mat-dialog-actions>
  <button gs1Button [name]="'dialog-reconnect'" (click)="reconnect()" cdkFocusInitial>Me reconnecter</button>
</div>
